import { render, staticRenderFns } from "./NoteWidget.vue?vue&type=template&id=1b4f9a52&scoped=true&"
import script from "./NoteWidget.vue?vue&type=script&lang=js&"
export * from "./NoteWidget.vue?vue&type=script&lang=js&"
import style0 from "./NoteWidget.vue?vue&type=style&index=0&id=1b4f9a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f9a52",
  null
  
)

export default component.exports